export interface VoiceRecord {
    id: number;
    projId: string;
    filename: string;
    uid: string;
    download_status: number;
    url: string;
    pwd: string;
    timeStamp: string;
    ossLink: string,
    waveLoading: boolean;
}

export interface VoiceRecordState {
    VoiceRecordList: VoiceRecord[],
    isLoading: boolean;
}

export const VoiceRecordDownloadStatus = {
    Idle: 0,
    Uploaded: 1,
    Downloading: 2,
    Downloaded: 3,
    Failed: 4,
    Playable: 6
}

export const VoiceRecordStatusFilter = [
    { text: '未知', value: 0 },
    { text: '已上传', value: 1 },
    { text: '下载中', value: 2 },
    { text: '已下载', value: 3 },
    { text: '失败', value: 4 },
    { text: '可播放', value: 6 },
]
